'use client';

import dynamic from 'next/dynamic';
import type { FC } from 'react';
import type { CoverSearchboxProps } from './CoverSearchbox.props';

/**
 * Client-only wrapper around the cover searchbox.
 *
 * `ssr: false` on purpose. The searchbox is not indexable content — it is an input — so nothing is
 * lost from the static shell by skipping it, while `HomeCover` stays a Server Component and keeps
 * its `<h1>`/`<h2>` prerendered (see MDC-4249).
 *
 * What is gained is that react-instantsearch never server-renders and then hydrates. Hydration is
 * where an InstantSearch instance can be disposed and re-rendered in the same pass, which is the
 * race behind `Cannot read properties of null (reading 'setClient')`. Combined with the memoised
 * client, the crash has no path left.
 *
 * The boundary lives here rather than in `HomeCover` because `ssr: false` is not allowed inside a
 * Server Component — wrapping at the module means every call site inherits it.
 */
const CoverSearchboxImpl = dynamic(() => import('./CoverSearchbox.component').then((m) => m.CoverSearchbox), {
  ssr: false,
});

const CoverSearchbox: FC<CoverSearchboxProps> = (props) => <CoverSearchboxImpl {...props} />;

export { CoverSearchbox };
